import { useQuery } from "@tanstack/react-query";
import { ApiService } from "@/services/api/ApiService";

export interface TeamListItem {
  id: number;
  name: string | null;
  brand: string | null;
  owner_id: string | null;
  owner: { id: string; full_name: string | null; email: string | null } | null;
  memberCount: number;
}

interface TeamsListResult {
  teams: TeamListItem[];
  count: number;
}

export const useTeamsList = (searchTerm: string = "", page: number = 1, pageSize: number = 50) => {
  return useQuery<TeamsListResult>({
    queryKey: ["teams-list", searchTerm, page, pageSize],
    queryFn: async () => {
      const result = await ApiService.invoke<{
        teams: TeamListItem[];
        count: number;
        limit: number;
        offset: number;
      }>({
        resource: "teams",
        action: "list",
        data: {
          limit: pageSize,
          offset: (page - 1) * pageSize,
          ...(searchTerm && { searchTerm }),
        },
      });

      return {
        teams: result?.teams ?? [],
        count: result?.count ?? 0,
      };
    },
  });
};
